import { render } from "./TechStack.vue?vue&type=template&id=52ce3bd0&scoped=true&bindings={\"isActive\":\"props\",\"showPopup\":\"data\",\"popups\":\"data\",\"popContent\":\"data\",\"openPopup\":\"options\",\"imgUrl\":\"options\"}"
import script from "./TechStack.vue?vue&type=script&lang=js"
export * from "./TechStack.vue?vue&type=script&lang=js"

import "./TechStack.vue?vue&type=style&index=0&id=52ce3bd0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-52ce3bd0"

export default script